import RichTextEditor from 'components/editor/RichTextEditor';
import { RichTextEditorProps } from 'components/editor/RichTextEditor.types';
import { useFormContext } from 'react-hook-form';
import GenericFormField from '../genericFormField/GenericFormField';
import {
  FieldRendererProps,
  GenericFormFieldBaseProps,
} from '../genericFormField/GenericFormField.types';
import { RichTextEditorFieldStyled } from './RichTextEditorField.styles';

export interface RichTextEditorFieldProps
  extends Omit<GenericFormFieldBaseProps, 'fieldRenderer' | 'name'> {
  controlsSettings?: RichTextEditorProps['controlsSettings'];
  customFooter?: RichTextEditorProps['customFooter'];
  name: string;
  placeholderText?: string;
  readOnly?: boolean;
}

const RichTextEditorField = ({
  controlsSettings,
  customFooter,
  name,
  placeholderText,
  readOnly,
  ...propsGenericField
}: RichTextEditorFieldProps) => {
  const { trigger, setValue } = useFormContext();
  const defaultControlsSettings = {
    attachmentsAvailable: false,
    attachmentIconDisabled: false,
    isLoading: false,
    clearEditorButton: false,
  };

  const fieldRenderer = ({ field: { value } }: FieldRendererProps) => {
    const onBlur = () => {
      // Triggers the form validation when the field loses focus
      trigger();
    };

    const onChange = (htmlContent: string) => {
      // If we use the same name, the field value is never updated and the editor adds a new line for every keystroke
      setValue(`${name}_htmlContent`, htmlContent, {
        shouldDirty: true,
      });
    };

    return (
      <RichTextEditorFieldStyled>
        <RichTextEditor
          contents={value}
          controlsSettings={controlsSettings ?? defaultControlsSettings}
          customFooter={customFooter}
          id={name}
          placeholderText={placeholderText}
          onBlur={onBlur}
          onChange={onChange}
          readOnly={readOnly}
        />
      </RichTextEditorFieldStyled>
    );
  };

  return (
    <GenericFormField
      fieldRenderer={fieldRenderer}
      name={name}
      {...propsGenericField}
    />
  );
};

RichTextEditorField.defaultProps = {
  controlsSettings: undefined,
  customFooter: undefined,
  placeholderText: undefined,
  readOnly: false,
};

export default RichTextEditorField;
